var _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_595_10756)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 80,
    height: 80,
    rx: 15,
    fill: "#EF5EA2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_595_10756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 29,
    width: 34,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.75 40.5H35.25C34.4216 40.5 33.75 41.1716 33.75 42V57C33.75 57.8284 34.4216 58.5 35.25 58.5H54.75C55.5784 58.5 56.25 57.8284 56.25 57V42C56.25 41.1716 55.5784 40.5 54.75 40.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 48C40.5784 48 41.25 47.3284 41.25 46.5C41.25 45.6716 40.5784 45 39.75 45C38.9216 45 38.25 45.6716 38.25 46.5C38.25 47.3284 38.9216 48 39.75 48Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.25 48C51.0784 48 51.75 47.3284 51.75 46.5C51.75 45.6716 51.0784 45 50.25 45C49.4216 45 48.75 45.6716 48.75 46.5C48.75 47.3284 49.4216 48 50.25 48Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 51C41.6022 51 41.2206 51.158 40.9393 51.4393C40.658 51.7206 40.5 52.1022 40.5 52.5C40.5 52.8978 40.658 53.2794 40.9393 53.5607C41.2206 53.842 41.6022 54 42 54V51ZM48 54C48.3978 54 48.7794 53.842 49.0607 53.5607C49.342 53.2794 49.5 52.8978 49.5 52.5C49.5 52.1022 49.342 51.7206 49.0607 51.4393C48.7794 51.158 48.3978 51 48 51V54ZM42 54H48V51H42V54Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34.5V40.5M30 46.5V52.5M60 46.5V52.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34.5C45.8284 34.5 46.5 33.8284 46.5 33C46.5 32.1716 45.8284 31.5 45 31.5C44.1716 31.5 43.5 32.1716 43.5 33C43.5 33.8284 44.1716 34.5 45 34.5Z",
    stroke: "white",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_595_10756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 27H63V63H27V27Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_595_10756",
    x: 0,
    y: 0,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_595_10756"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_595_10756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_595_10756",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/service-6.b34d7c24142db1a135ce674b582742e1.svg";
export { ForwardRef as ReactComponent };